// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-930a9a7a] .filters-column span+span:before{content:\"/\"}", ""]);
// Exports
module.exports = exports;
